import ContractFilter from '@/domain/contract/entity/contract-filter.entity';

export default class BillingContractsSelected {
  businessUnitId: string;

  invoiceCompetence: string;

  contractFilter: ContractFilter = new ContractFilter({});

  constructor(obj: any = {}) {
    this.businessUnitId = obj.businessUnitId || '';
    this.invoiceCompetence = obj.invoiceCompetence;
    this.contractFilter = obj.contractFilter;
  }

  public static of(obj: any = {}): BillingContractsSelected {
    return new BillingContractsSelected(obj);
  }

  public static ofList(obj: any[]): BillingContractsSelected[] {
    return obj.map(this.of);
  }
}
